import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./tickets.component.css'],
})
export class TicketsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
